import { Component, OnInit, Input } from '@angular/core';
import { OrderingService } from '../../../../../services';

@Component({
  selector: '[order-volume-discount]',
  templateUrl: './order-volume-discount.component.html',
  styleUrls: ['./order-volume-discount.component.css']
})
export class OrderVolumeDiscountComponent implements OnInit {
  @Input()product;
  @Input()orders;
  @Input()discount;

  constructor(
    private orderingService: OrderingService
  ) { }

  ngOnInit() {
  }
}
